import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { IDepartment } from 'app/models/sharing.models';
import { AuthService } from './auth.service';
import { map } from 'rxjs/operators';
import { StorageKeys } from 'app/constants/common.constants';

@Injectable({
  providedIn: 'root',
})
export class SharingService {
  constructor(
    private http: HttpClient,
    private authService: AuthService,
  ) {}

  getDepartmentRelations(ids: number | number[]): Observable<IDepartment[]> {
    const params = new HttpParams().set('ids', Array.isArray(ids) ? ids.join(',') : ids.toString());
    return this.http.get<IDepartment[]>(`${environment.apiUrl}/api/analytics/department-relations/enriched`, {
      params,
    });
  }

  loadDepartmentRelations(): Observable<IDepartment[]> {
    return this.getDepartmentRelations(this.authService.getDepartmentId()).pipe(
      map((data: IDepartment[]) => {
        const list = (data ?? []).map((item: IDepartment) => item.id);
        sessionStorage.setItem(StorageKeys.DEPARTMENT_RELATIONS, JSON.stringify(list));
        return data;
      }),
    );
  }
}
